import {
  Button,
  Col,
  Container,
  Dropdown,
  FloatingLabel,
  Form,
  Placeholder,
  Row,
  Tab,
  Table,
  Tabs,
} from "react-bootstrap";
import { FloatInput, FloatSelect, HeadPage } from "src/componentes";
import TributacaoCadastroCode from "./TributacaoCadastro.Code";
import { useEffect, useState } from "react";
import { IRoute } from "src/interfaces/IRoute";
import { useNavigate, useSearchParams } from "react-router-dom";

const TributacaoCadastroView = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [menuItens, setMenuItens] = useState<IRoute[]>([]);
  const navigate = useNavigate();
  const { register, errors, handleSubmit, onSubmit, loading, incluir, data } =
    TributacaoCadastroCode();

  useEffect(() => {
    if (!incluir) {
      setMenuItens([
        {
          name: "Nova Cfop...",
          route: `/fiscal/tributacao/cfop/cadastro?tributacaoid=${id}`,
        },
      ]);
    }
  }, []);

  const handleClickNavigate = (route: string) => () => {
    navigate(route);
  };

  const handleClickAlterar = (id: number, tributacaoId: number) => () => {
    navigate(
      `/fiscal/tributacao/cfop/cadastro?id=${id}&tributacaoid=${tributacaoId}`
    );
  };

  return (
    <Container>
      <Form noValidate onSubmit={handleSubmit(onSubmit)}>
        <HeadPage headText="Tributacao Cadastro">
          {menuItens !== undefined &&
            menuItens.map((item) => (
              <Dropdown.Item
                key={item.name}
                onClick={handleClickNavigate(item.route)}
              >
                {item.name}
              </Dropdown.Item>
            ))}
        </HeadPage>
        {!loading ? (
          <Tabs defaultActiveKey="tabDados">
            <Tab eventKey="tabDados" title="Dados">
              <>
                <Row>
                  <Col>
                    <Col xs={12}>
                      <FloatInput
                        registerField={register("nome")}
                        label="Nome"
                        errorsMessage={errors.nome}
                        inputMask="capitalizar"
                      />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Col xs={12}>
                      <FloatInput
                        label="Natureza Operação"
                        errorsMessage={errors.naturezaOperacao}
                        registerField={register("naturezaOperacao")}
                        inputMask="capitalizar"
                      />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Col xs={12}>
                      <FloatSelect
                        label="Tipo Operação"
                        options={[
                          { label: "Selecione" },
                          { value: "0", label: "Entrada" },
                          { value: "1", label: "Saída" },
                        ]}
                        register={register("tipoOperacao")}
                        errorsMessage={errors.tipoOperacao}
                      />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Form.Group>
                      <Form.Check type="checkbox" id="padraoEmissaoCupomFiscal">
                        <Form.Check.Input
                          type="checkbox"
                          {...register("padraoEmissaoCupomFiscal")}
                          title="Tooltip on top"
                        ></Form.Check.Input>
                        <Form.Check.Label>
                          Emissão cupom fiscal?
                        </Form.Check.Label>
                      </Form.Check>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} className="d-grid mt-3 mb-5">
                    <Button type="submit">Confirmar</Button>
                  </Col>
                </Row>
              </>
            </Tab>
            {!incluir && (
              <Tab eventKey="tabCfop" title="Cfop">
                <Row>
                  <Col>
                    <Table responsive striped hover>
                      <thead>
                        <tr>
                          <th className="col-2">CFOP</th>
                          <th className="col-5">Tipo Parâmetro</th>
                          <th className="col-5">Impostos</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data
                          ?.sort((a, b) => {
                            const firstDigitA = parseInt(a.cfop[0]);
                            const firstDigitB = parseInt(b.cfop[0]);

                            if (firstDigitA !== firstDigitB) {
                              return firstDigitA - firstDigitB;
                            }

                            return a.tipoParametro - b.tipoParametro;
                          })
                          .map((item) => (
                            <tr
                              key={item.id}
                              onClick={handleClickAlterar(
                                item.id,
                                item.tributacaoId
                              )}
                              style={{ cursor: "pointer" }}
                            >
                              <td className="col-2">{item.cfop}</td>
                              <td className="col-5">
                                {item.tipoParametro} -{" "}
                                {item.tipoParametroDescricao}{" "}
                                {item.tipoParametro !== 0
                                  ? `[${item.parametroValor}]`
                                  : ""}
                              </td>
                              <td className="col-5">
                                {item.impostos
                                  .sort((a, b) => a.tipoImposto - b.tipoImposto)
                                  .map((imposto, index) => (
                                    <>
                                      {index > 0 && <br />}{" "}
                                      {/* Adiciona uma nova linha, exceto antes do primeiro item */}
                                      {imposto.tipoImpostoDescricao +
                                        " [" +
                                        imposto.cst +
                                        "]"}
                                    </>
                                  ))}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Tab>
            )}
          </Tabs>
        ) : (
          <Placeholder as={FloatingLabel} animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Form>
    </Container>
  );
};

export default TributacaoCadastroView;
